import { Button } from '@/components/ui/button';
import { ArrowRightIcon, RefreshCwIcon, WandIcon, Loader2Icon } from 'lucide-react';
import React from 'react';
import EmailToggle from './email-toggle';

export function AIPrompt({
	placeholder,
	value,
	onChange,
	extra_label,
	additional_label,
	onCallback,
	isLoading,
	ref
}: {
	placeholder: string;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	extra_label?: string;
	additional_label?: string;
	onCallback?: () => void;
	isLoading?: boolean;
	ref?: React.RefObject<HTMLInputElement>;
}) {
	// Function to handle "Enter" key press
	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter' && onCallback) {
			e.preventDefault(); // Prevent default form submission behavior
			onCallback(); // Call the callback function
		}
	};

	return (
		<div className="max-w-2xl mx-auto">
			<div
				className={`relative flex items-center p-4 bg-white rounded-full shadow-xl ${isLoading ? 'opacity-50' : ''}`}
			>
				{/* <WandIcon className="w-6 h-6 text-gray-500 mr-3" /> */}
				<input
					type="text"
					placeholder={placeholder}
					value={value}
					onChange={onChange}
					onKeyDown={handleKeyDown} // Add onKeyDown handler to listen for Enter key
					className="flex-1 text-lg text-blue-600 bg-transparent border-none focus:outline-none px-2"
					disabled={isLoading} // Disable input when loading
					ref={ref}
				/>
				{extra_label && <span className="text-gray-500 mr-3">{extra_label}</span>}
				<Button
					variant="ghost"
					size="icon"
					className="rounded-full"
					onClick={onCallback}
					disabled={isLoading} // Disable button when loading
				>
					{isLoading ? (
						<Loader2Icon className="w-6 h-6 text-black animate-spin" /> // Loading spinner
					) : (
						<ArrowRightIcon className="w-6 h-6 text-black" />
					)}
				</Button>
			</div>
			{additional_label && (
				<div className="flex items-center mt-2 text-gray-500">
					<RefreshCwIcon className="w-5 h-5 mr-2" />
					<span className="flex-1 truncate">{additional_label}</span>
				</div>
			)}
		</div>
	);
}
